<template>
    <div class="full-screen">
        <feather-icon
            icon="MaximizeIcon"
            size="18"
            class="text-body cursor-pointer"
            @click="action"
        />
    </div>
</template>
<script>
export default {
    props: {
        eid: {
            type: String,
            require: true
        }
    },
    setup(props, ctx){
        const action = ()=>{
            var elem = document.getElementById(props.eid);
            if (elem.requestFullscreen) {
                elem.requestFullscreen();
            } else if (elem.msRequestFullscreen) {
                elem.msRequestFullscreen();
            } else if (elem.mozRequestFullScreen) {
                elem.mozRequestFullScreen();
            } else if (elem.webkitRequestFullscreen) {
                elem.webkitRequestFullscreen();
            }
        }
        
        return {
            action
        }
    }
}
</script>
<style lang="scss">
:fullscreen, ::backdrop {
  background-color: white;
}
.dark-layout {
    :fullscreen, ::backdrop {
        background-color: black;
    }
}
</style>